import { Player } from '@lottiefiles/react-lottie-player'

import { LoaderTypes, TypesLoader } from './model'
import styles from './styles.module.scss'

interface Props {
  marginTop?: number
  type?: LoaderTypes
}

export const Loader = ({ marginTop, type = TypesLoader.avia.key }: Props) => {
  const fileLoader = TypesLoader[type].file

  return (
    <div
      className={styles.wrapper}
      style={{ marginTop: `${marginTop}px` }}
    >
      <div className={styles.container}>
        <Player
          loop
          autoplay
          renderer={'svg'}
          src={fileLoader}
        />
      </div>
    </div>
  )
}
